import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { reportActions } from '../../store/reportStore';
import ReportExpander from "../common/reportExpander";
import { czSk } from '../common/reportLinks';
import ReportSection from '../common/reportSection';

import "../../css/common/sticky-table.scss";

class ESGReport extends React.Component {
    componentDidMount() {
        this.props.requestGetReportSettings(this.props.match.params.id, 'ESGReport');
        this.props.ensureEntityInfo(this.props.match.params.id);
    };

    constructor(props) {
        super(props);
        this.state = { reloaded: false };
    }

    componentDidUpdate(prevProps) {
        if (this.props.requestedReload === true && !this.state.reloaded) {
            this.props.requestGetReportSettings(this.props.match.params.id, 'ESGReport');
            this.setState({ reloaded: true });
        }
        if (this.props.requestedReload === false && this.state.reloaded)
            this.setState({ reloaded: false });
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.props.ensureEntityInfo(this.props.match.params.id);
        }
    }

    componentWillUnmount() {
        this.props.onLeavingReport();
        this.props.toggleSectionEditMode(false);
        if (this.props.sections) {
            this.props.restoreConfig();
        }
    }

    render() {
        if (!this.isLoaded(this.props.match.params.id, this.props.entity.entityInfos)) {
            return null;
        }

        if (this.hasReportPermission(this.props.match.params.id, this.props.entity.entityInfos, "ESGReportCZ", "ESGReportSK")) {
            return (
                <React.Fragment>
                    <ReportExpander />
                    {this.props.sections && this.props.sections.filter(s => !s.hidden).map(s => <ReportSection key={s.id + '-' + s.orderId} sectionId={s.id} />)}
                </React.Fragment>
            );
        } else
            return <Redirect to={`/notAuthorized?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
    };

    isLoaded(id, entityInfos) {
        return id && entityInfos[id] && !entityInfos[id].isRequesting;
    }

    hasReportPermission(id, entityInfos, czRole, skRole) {
        return id && entityInfos[id] && !entityInfos[id].isRequesting && entityInfos[id].result && entityInfos[id].result.reports &&
            czSk(entityInfos[id].result.reports.primaryAttr, czRole, skRole);
    }
}

export default withRouter(connect(
    state => ({ ...state.report, entity: state.entityIdentRow }),
    dispatch => bindActionCreators({ ...reportActions, ...entityIdentRowActions }, dispatch)
)(ESGReport));